// global state without needing a store: /code/web/vue3/prototype/global-store-test/README.md
import { ref } from "vue";
import { Strategy } from "@spike/app2-sitemap/src/auth.js";

export interface GlobalStore {
  email?: string;
  strategy?: Strategy;
}

// oauth sign-ups redirect to /auth with query strings
const _email = query("email") as string | undefined;
const _provider = query("provider") as Strategy | undefined;

function query(param: string, isNumber = false) {
  const searchParams = new URLSearchParams(window.location.search);
  const p = searchParams.get(param);
  if (p) {
    return isNumber ? +p : p;
  }
  return undefined;
}

export const email = ref<string | undefined>(_email);
export const strategy = ref<Strategy | undefined>(_provider);
export const forgotEmail = ref<string | undefined>(_email);

export function setEmail(v: string): void {
  email.value = v;
}

export function setStrategy(v: Strategy): void {
  strategy.value = v;
}

export function setForgotEmail(v: string): void {
  forgotEmail.value = v;
}
